import { FelaCSS, colors } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  text: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    color: colors.space40,
    alignItems: 'center',

    ':hover': {
      color: colors.space60,
    },
  },

  text: {
    marginLeft: '8px',
    fontDefault: 14,
    lineHeight: '20px',
    display: 'inline-block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    flexDirection: 'row',
  },
});

export default styles;
